import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { undoStore } from '../../stores/undo/UndoStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faPuzzlePiece, faRedo, faUndo } from '@fortawesome/free-solid-svg-icons';
import { dataConstants } from '../../../shared/data/dataConstants';
import { DebugWait } from '../debug/DebugWait';
import { localSettingsStore } from '../../stores/LocalSettingsStore';
const UndoRedoDebugArea = styled.div.withConfig({
  displayName: "HeaderUndoRedo__UndoRedoDebugArea",
  componentId: "sc-1bkdcgw-0"
})(["position:absolute;background:rgba(255,255,255,0.5);pointer-events:none;white-space:nowrap;"]);
export const HeaderUndoRedo = observer(() => {
  const {
    t
  } = useTranslation();
  const {
    hasUndo,
    hasRedo
  } = undoStore;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, false && dataConstants.isDevelopment && /*#__PURE__*/React.createElement(DebugWait, null), /*#__PURE__*/React.createElement("button", {
    disabled: !hasUndo,
    onClick: undoStore.undo
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faUndo
  }), " ", t("editor.undo")), /*#__PURE__*/React.createElement("button", {
    disabled: !hasRedo,
    onClick: undoStore.redo
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faRedo
  }), " ", t("editor.redo"))), localSettingsStore.showUndoHistoryDebug && /*#__PURE__*/React.createElement(UndoRedoDebugArea, null, undoStore.redoQueue.length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ol", {
    reversed: true,
    start: undoStore.undoQueue.length + undoStore.redoQueue.length
  }, undoStore.redoQueue.map((element, i) => /*#__PURE__*/React.createElement("li", {
    key: i,
    style: i == undoStore.redoQueue.length - 1 ? {
      fontWeight: "bold"
    } : null
  }, t(element.nameTranslationKey), element.isBusy && /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCog,
    spin: true
  })), i == undoStore.redoQueue.length - 1 ? ` ← ${t("editor.redo")}` : ""))), /*#__PURE__*/React.createElement("hr", null)), undoStore.undoQueue.length > 0 && /*#__PURE__*/React.createElement("ol", {
    reversed: true,
    start: undoStore.undoQueue.length
  }, undoStore.undoQueue.slice().reverse().slice(0, 5).map((element, i) => /*#__PURE__*/React.createElement("li", {
    key: i,
    style: i == 0 ? {
      fontWeight: "bold"
    } : null
  }, t(element.nameTranslationKey), element.mayTryMerge && /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faPuzzlePiece
  })), element.isBusy && /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCog,
    spin: true
  })), i == 0 ? ` ← ${t("editor.undo")}` : "")), undoStore.undoQueue.length > 5 && /*#__PURE__*/React.createElement("li", null, "..."))));
});